export default "__VITE_ASSET__63645031__"